import { IndicatorName, PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
// eslint-disable-next-line import/no-cycle
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useOrganizationIndicatorGraphFact } from '@/pages/shared/hooks/useOrganizationFact';

import { useForestIntelligenceChart } from './useForestIntelligenceChart';

type ForestIntelligenceFactType = Partial<PlotReportFactElement> & { fact_name: string };

export const PlotGroupForestIntelligenceChart = () => {
  const { [IndicatorName.forest_intelligence_ecoregion_graph]: fact } = useOrganizationIndicatorGraphFact<GraphFact[]>(
    IndicatorName.forest_intelligence_ecoregion_graph,
  );

  const ecoregionGroups = fact?.value;

  const factsGroupedByEcoregion = ecoregionGroups?.reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, group: Record<string, any>) => {
      const groupKey = group.group_name;

      if (!acc[`${groupKey}`]) {
        acc[`${groupKey}`] = [];
      }

      const groupKeyFacts = group.group_key_facts;
      const ecoregionFact = groupKeyFacts.find(
        (keyFact: ForestIntelligenceFactType) => keyFact.fact_name === IndicatorName.forest_intelligence_ecoregion_id,
      );

      const groupForestIntelligenceFacts = group.group_value_facts.map((valueFact: ForestIntelligenceFactType) => ({
        ...valueFact,
        name: valueFact.fact_name,
      }));
      const groupFacts = [{ ...ecoregionFact, name: ecoregionFact?.fact_name }, ...groupForestIntelligenceFacts];

      if (groupFacts) acc[`${groupKey}`]?.push(groupFacts);

      return acc;
    }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {} as Record<string, Record<string, any>>,
  );

  const widgets = factsGroupedByEcoregion
    ? Object.entries(factsGroupedByEcoregion).map(([groupKey, groupFacts]) => {
        return <ForestIntelligenceChart facts={groupFacts.flat()} key={`${groupKey}`} />;
      })
    : undefined;
  return <>{widgets}</>;
};

const ForestIntelligenceChart = ({ facts }: { facts: PlotReportFactElement[] }) => {
  const widgetConfiguration = useForestIntelligenceChart({ facts });
  return <WidgetSlotRenderer nestedWidget={widgetConfiguration} />;
};
